'use strict';

exports.__esModule = true;

var _templateObject = _taggedTemplateLiteralLoose(['\n  height: 100vh;\n'], ['\n  height: 100vh;\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  height: auto;\n  width: 300px;\n  margin-bottom: ', 'px;\n'], ['\n  height: auto;\n  width: 300px;\n  margin-bottom: ', 'px;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _gridStyled = require('grid-styled');

var _InfiniteLoadingBar = require('../infiniteLoadingBar/InfiniteLoadingBar');

var _InfiniteLoadingBar2 = _interopRequireDefault(_InfiniteLoadingBar);

var _Space = require('../base/Space');

var _Space2 = _interopRequireDefault(_Space);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

var SplashContainer = (0, _styledComponents2.default)(_gridStyled.Flex)(_templateObject);

var Logo = _styledComponents2.default.img(_templateObject2, _Space2.default[10]);

var Splash = function Splash(_ref) {
  var logoUrl = _ref.logoUrl;
  return _react2.default.createElement(
    SplashContainer,
    {
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      width: 1,
      height: '100'
    },
    _react2.default.createElement(Logo, { src: logoUrl, alt: 'logo' }),
    _react2.default.createElement(_InfiniteLoadingBar2.default, { width: 300 })
  );
};

Splash.propTypes = process.env.NODE_ENV !== "production" ? {
  logoUrl: _propTypes2.default.string.isRequired
} : {};

exports.default = Splash;
module.exports = exports['default'];